import { GenericCollectionFactory } from "../../Common/_generics/GenericCollectionFactory";

export const PMSLocationReservationsCollection = GenericCollectionFactory("PMS_LOCATION_RESERVATIONS", "uid")